import React, { useEffect } from "react";
import PureCounter from '@srexi/purecounterjs'; 
import "../assets/css/main.css";

function Stats() {
  const statsData = [
    {
      icon: "bi-emoji-smile",
      color: "color-blue",
      count: 563,
      text: "Happy Clients",
    },
    // {
    //   icon: "bi-journal-richtext",
    //   color: "color-orange",
    //   style: { color: "#ee6c20" },
    //   count: 521,
    //   text: "Projects",
    // },
    {
      icon: "bi-headset",
      color: "color-green",
      style: { color: "#15be56" },
      count: "24 / 7",
      text: "Hours Of Support",
    },
    {
      icon: "bi-people",
      color: "color-pink",
      style: { color: "#bb0852" },
      count: 15,
      text: "Dedicated Team to solve particular Issues",
    },
  ];

  useEffect(() => {
    new PureCounter(); 
  }, []);

  return (
    <section id="stats" className="stats section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {statsData.map((stat, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="stats-item d-flex align-items-center w-100 h-100">
                <i
                  className={`bi ${stat.icon} ${stat.color} flex-shrink-0`}
                  style={stat.style}
                ></i>
                <div>
                  {stat.count === "24 / 7" ? (
                    <span>{stat.count}</span>
                  ) : (
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end={stat.count}
                      data-purecounter-duration="1"
                      className="purecounter"
                    ></span>
                  )}
                  <p>{stat.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
